import React, { useContext } from 'react'
import { PlayerContext } from '../../../../../Context'
import { RosterTable } from '../../../../../Components/Tables/RosterTable'

export const ChampSeriesRoster: React.FC = () => {
  const { isRosterLoading, teamName, champSeriesRoster } = useContext(PlayerContext)!

  return (
    <>
      {!isRosterLoading && champSeriesRoster.length > 0 && (
        <RosterTable
          roster={champSeriesRoster}
          rosterType="Champ Series"
          location={`${teamName} Champ Series Roster`}
        />
      )}
    </>
  )
}
